export const CHANGE_FIELD_VALUE = 'CHANGE_FIELD_VALUE';
export const UPDATE_MODEL_OPTIONS = 'UPDATE_MODEL_OPTIONS';
export const CLEAR_VEHICLES_RESULT = 'CLEAR_VEHICLES_RESULT';
export const MAKES_SUCCESS = 'MAKES_SUCCESS';
export const TOUCH_ALL_FIELDS = 'TOUCH_ALL_FIELDS';
